import { cn } from '@/lib/cn'

/**
 * The Arva SEO logo from the brand files (public/brand, copied from
 * brand/logos/svg). `light` is the version for ink backgrounds; `dark` is for
 * bone backgrounds and switches to the ink-background version in dark mode.
 */
export function Logo({ className, tone = 'light' }: { className?: string; tone?: 'light' | 'dark' }) {
  const size = 'h-8 w-auto'
  return tone === 'light' ? (
    <img
      src="/brand/arvaseo-logo-on-dark.svg?v=20261012"
      alt="Arva SEO"
      width={126}
      height={32}
      className={cn(size, className)}
    />
  ) : (
    <span className={cn('inline-flex', className)}>
      <img
        src="/brand/arvaseo-logo-on-light.svg?v=20261012"
        alt="Arva SEO"
        width={126}
        height={32}
        className={cn(size, 'dark:hidden')}
      />
      <img
        src="/brand/arvaseo-logo-on-dark.svg?v=20261012"
        alt="Arva SEO"
        width={126}
        height={32}
        className={cn(size, 'hidden dark:block')}
      />
    </span>
  )
}
